import { createSlice } from '@reduxjs/toolkit';
import { localStorageManager } from 'services/localStorage';
import { IAuthState } from './authTypes';

const initialState: IAuthState = {
  user: localStorageManager.getUser(),
  role: localStorageManager.getUserRole(),
  aPlayerStatus: localStorageManager.getAPlayerStatus(),
  loading: false,
  error: null,
};

export const authReducer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setAuthSuccess: (state, action) => {
      state.user = action.payload.user;
      state.role = action.payload.role;
      state.aPlayerStatus = action.payload.aPlayerStatus ?? null;
      state.loading = false;
      state.error = null;
    },
    setAuthError: (state, action) => {
      state.user = null;
      state.role = null;
      state.aPlayerStatus = null;
      state.loading = false;
      state.error = action.payload;
    },
    resetAuthState: (state) => {
      state.user = null;
      state.role = null;
      state.aPlayerStatus = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setAuthLoading, setAuthSuccess, setAuthError, resetAuthState } =
  authReducer.actions;

export default authReducer.reducer;
